import styled from 'styled-components';

export const Box = styled.div<{ $radius: string }>`
	width: 64px;
	height: 64px;
	background-color: ${({ theme }) => theme.gray[400]};
	border-radius: ${({ $radius }) => $radius};
`;
